// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/PPNeueMontreal-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/PPNeueMontreal-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/PPNeueMontreal-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Inconsolata-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Inconsolata-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,body
{
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden; 
}

@font-face {
  font-family: PPNeueMontreal-Regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
}

@font-face {
  font-family: PPNeueMontreal-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 500;
}
@font-face {
  font-family: PPNeueMontreal-SemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 600;
}
@font-face {
  font-family: Inconsolata-Regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 500;
}
@font-face {
  font-family: Inconsolata-SemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 700;
}

body {
  margin: 0;
  font-family: 'PPNeueMontreal-Regular';
}

.custom-datepicker-popup .MuiCalendarOrClockPicker-root .MuiCalendarPicker-root {
  width: 303px;
  font-family: 'PPNeueMontreal-Regular';
}
.custom-datepicker-popup .MuiCalendarOrClockPicker-root > div {
  width: 303px;
}
.custom-datepicker-popup .MuiCalendarOrClockPicker-root > div {
  width: 303px;
}
.custom-datepicker-popup
  .MuiCalendarOrClockPicker-root
  .MuiCalendarPicker-root
  .MuiButtonBase-root.MuiPickersDay-root.Mui-selected {
  background-color: #0f62fe;
}

.custom-datepicker-popup
  .MuiCalendarOrClockPicker-root
  .MuiCalendarPicker-root
  .MuiMonthPicker-root {
  width: auto;
  margin: 0;
  padding: 0 8px;
}
.custom-datepicker-popup
  .MuiCalendarOrClockPicker-root
  .MuiCalendarPicker-root
  .MuiMonthPicker-root
  .PrivatePickersMonth-root.Mui-selected {
  background-color: #0f62fe;
  color: #fff;
}
.custom-datepicker-popup
  .MuiCalendarOrClockPicker-root
  .MuiCalendarPicker-root
  .MuiMonthPicker-root
  .PrivatePickersMonth-root {
  margin: 8px 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #161717;
}

.custom-datepicker-popup
  .MuiCalendarOrClockPicker-root
  .MuiCalendarPicker-root
  .PrivatePickersYear-yearButton.Mui-disabled {

  color: #D8DEE3;
}

.custom-datepicker-popup
  .MuiCalendarOrClockPicker-root
  .MuiCalendarPicker-root
  .PrivatePickersYear-yearButton {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
}
.custom-datepicker-popup
  .MuiCalendarOrClockPicker-root
  .MuiCalendarPicker-root
  .PrivatePickersYear-yearButton.Mui-selected {
  background-color: #0f62fe;
}
.custom-datepicker-popup .PrivatePickersSlideTransition-root.MuiDayPicker-slideTransition {
  min-height: 210px;
}
.custom-datepicker-popup .MuiPickersCalendarHeader-label {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #161717;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;EACE,mCAAmC;EACnC,4CAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,4CAAkD;EAClD,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,4CAAoD;EACpD,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,4CAAgD;EAChD,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,4CAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,WAAW;EACX,SAAS;EACT,cAAc;AAChB;AACA;;;;;EAKE,yBAAyB;EACzB,WAAW;AACb;AACA;;;;;EAKE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,body\n{\n    width: 100%;\n    height: 100%;\n    margin: 0px;\n    padding: 0px;\n    overflow-x: hidden; \n}\n\n@font-face {\n  font-family: PPNeueMontreal-Regular;\n  src: url(./assets/fonts/PPNeueMontreal-Regular.otf);\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: PPNeueMontreal-Medium;\n  src: url(./assets/fonts/PPNeueMontreal-Medium.otf);\n  font-weight: 500;\n}\n@font-face {\n  font-family: PPNeueMontreal-SemiBold;\n  src: url(./assets/fonts/PPNeueMontreal-SemiBold.otf);\n  font-weight: 600;\n}\n@font-face {\n  font-family: Inconsolata-Regular;\n  src: url(./assets/fonts/Inconsolata-Regular.ttf);\n  font-weight: 500;\n}\n@font-face {\n  font-family: Inconsolata-SemiBold;\n  src: url(./assets/fonts/Inconsolata-SemiBold.ttf);\n  font-weight: 700;\n}\n\nbody {\n  margin: 0;\n  font-family: 'PPNeueMontreal-Regular';\n}\n\n.custom-datepicker-popup .MuiCalendarOrClockPicker-root .MuiCalendarPicker-root {\n  width: 303px;\n  font-family: 'PPNeueMontreal-Regular';\n}\n.custom-datepicker-popup .MuiCalendarOrClockPicker-root > div {\n  width: 303px;\n}\n.custom-datepicker-popup .MuiCalendarOrClockPicker-root > div {\n  width: 303px;\n}\n.custom-datepicker-popup\n  .MuiCalendarOrClockPicker-root\n  .MuiCalendarPicker-root\n  .MuiButtonBase-root.MuiPickersDay-root.Mui-selected {\n  background-color: #0f62fe;\n}\n\n.custom-datepicker-popup\n  .MuiCalendarOrClockPicker-root\n  .MuiCalendarPicker-root\n  .MuiMonthPicker-root {\n  width: auto;\n  margin: 0;\n  padding: 0 8px;\n}\n.custom-datepicker-popup\n  .MuiCalendarOrClockPicker-root\n  .MuiCalendarPicker-root\n  .MuiMonthPicker-root\n  .PrivatePickersMonth-root.Mui-selected {\n  background-color: #0f62fe;\n  color: #fff;\n}\n.custom-datepicker-popup\n  .MuiCalendarOrClockPicker-root\n  .MuiCalendarPicker-root\n  .MuiMonthPicker-root\n  .PrivatePickersMonth-root {\n  margin: 8px 0;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  color: #161717;\n}\n\n.custom-datepicker-popup\n  .MuiCalendarOrClockPicker-root\n  .MuiCalendarPicker-root\n  .PrivatePickersYear-yearButton.Mui-disabled {\n\n  color: #D8DEE3;\n}\n\n.custom-datepicker-popup\n  .MuiCalendarOrClockPicker-root\n  .MuiCalendarPicker-root\n  .PrivatePickersYear-yearButton {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n}\n.custom-datepicker-popup\n  .MuiCalendarOrClockPicker-root\n  .MuiCalendarPicker-root\n  .PrivatePickersYear-yearButton.Mui-selected {\n  background-color: #0f62fe;\n}\n.custom-datepicker-popup .PrivatePickersSlideTransition-root.MuiDayPicker-slideTransition {\n  min-height: 210px;\n}\n.custom-datepicker-popup .MuiPickersCalendarHeader-label {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  color: #161717;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
